import * as types from '../../mutation-types'
import axios from "axios";

export const fetchQuiz = async ({commit}, quizId) => {
    try {
        const {data} = await axios.get(process.env.API_URL + '/quiz/' + quizId)
        commit(types.FETCH_QUIZ_SUCCESS, data)
    } catch (e) {
        commit(types.FETCH_QUIZ_FAILURE)
    }
};

export const fetchProfile = async ({commit}, params) => {
    try {
        const {data} = await axios.get(process.env.API_URL + '/get-profile-data/user/' + params.userId + '/quiz/' + params.quizId);
        commit(types.FETCH_PROFILE_SUCCESS, data)
    } catch (e) {
        commit(types.FETCH_PROFILE_FAILURE)
    }
};

export const saveProfile = async ({commit}, formData) => {
    await axios.post(process.env.API_URL + '/save-curl-profile', formData);
}

export const fetchRegimenElements = async ({commit}, formData) => {
    try {
        const {data} = await axios.post(process.env.API_URL + '/get-regimen-elements',  formData);
        commit(types.FETCH_REGIMEN_ELEMENTS_SUCCESS, data)
    } catch (e) {
        commit(types.FETCH_REGIMEN_ELEMENTS_FAILURE)
    }
};

export const fetchAllRegimenElements = async ({commit}) => {
    try {
        const {data} = await axios.get(process.env.API_URL + '/get-all-regimen-elements');
        commit(types.FETCH_ALL_REGIMEN_ELEMENTS_SUCCESS, data)
    } catch (e) {
        commit(types.FETCH_ALL_REGIMEN_ELEMENTS_FAILURE)
    }
};

export const fetchUserRegimenElements = async ({commit}, formData) => {
    try {
        const {data} = await axios.get(process.env.API_URL + '/get-user-regimen-elements/' + formData.userId);
        commit(types.FETCH_USER_REGIMEN_ELEMENTS_SUCCESS, data)
    } catch (e) {
        commit(types.FETCH_USER_REGIMEN_ELEMENTS_FAILURE)
    }
};

export const userRegimenElement = async ({commit}, formData) => {
    await axios.post(process.env.API_URL + '/user-regimen-element', formData);
}

export const saveNote = async ({commit}, formData) => {
    await axios.post(process.env.API_URL + '/save-note', formData);
}

export const deleteNote = async ({commit}, formData) => {
    await axios.post(process.env.API_URL + '/delete-note', formData);
}

export const fetchNotes = async ({commit}, params) => {
    try {
        const {data} = await axios.get(process.env.API_URL + '/get-notes/' + params.userId);
        commit(types.FETCH_NOTES_SUCCESS, data)
    } catch (e) {
        commit(types.FETCH_NOTES_FAILURE)
    }
}

export const fetchInsights = async ({commit}, params) => {
    try {
        const {data} = await axios.get(process.env.API_URL + '/get-insights/' + params.userId);
        commit(types.FETCH_INSIGHTS_SUCCESS, data)
    } catch (e) {
        commit(types.FETCH_INSIGHTS_FAILURE)
    }
}

export const updateInsights = async ({commit, dispatch}, formaData) => {
    // const { insightId } = params;
    await axios.post(process.env.API_URL + '/update-insights/' + 33,formaData);
    dispatch('fetchInsights', params )
}

export const approveInsight = async ({commit, dispatch}, insight) => {
    await axios.post(process.env.API_URL + '/approve-insights/' + insight.id);
}

export const rejectInsight = async ({commit, dispatch}, insight) => {
    await axios.post(process.env.API_URL + '/reject-insights/' + insight.id);
}

export const renewalInsight = async ({commit, dispatch}, formData) => {
    await axios.post(process.env.API_URL + '/renewal-insights/' + formData.insightId, formData);
}

export const updateNotifications = async ({commit, dispatch}, params) => {
    await axios.post(process.env.API_URL + '/update-notification/' + params.notificationId);
    dispatch('fetchUser')
}

export const updateInsightRate = async ({commit}, formData) => {
    await formData.post(process.env.API_URL + '/rate-notification');
}




// WEBPACK FOOTER //
// ./src/store/modules/quiz/actions.js